class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.duration = 350;
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onSummaryClick(event) {
    // Intercept closing clicks so the menu can roll up before <details> hides it.
    if (this.mainDetailsToggle.open && !this.isClosing) {
      event.preventDefault();
      this.close();
    }
  }

  // Roller-blind reveal: clip-path unrolls the content from top to bottom.
  animate(closing) {
    if (this.currentAnimation) this.currentAnimation.cancel();

    const keyframes = [
      { clipPath: 'inset(0 0 100% 0)', opacity: 0 },
      { clipPath: 'inset(0 0 0 0)', opacity: 1 },
    ];

    this.currentAnimation = this.content.animate(closing ? keyframes.slice().reverse() : keyframes, {
      duration: this.duration,
      easing: 'ease',
      fill: 'both',
    });

    return this.currentAnimation;
  }

  close() {
    // Nothing to roll up when the menu is already closed. Without this the sticky header's
    // closeMenuDisclosure() would leave a closing animation running on every scroll frame,
    // and the next click would open the menu straight into that animation.
    if (this.isClosing || !this.mainDetailsToggle.open) return;
    this.isClosing = true;

    const animation = this.animate(true);

    animation.finished
      .then(() => {
        this.mainDetailsToggle.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', false);
      })
      // Cancelled because the menu was re-opened mid-close: leave it open.
      .catch(() => {})
      .finally(() => {
        this.isClosing = false;
        if (this.currentAnimation === animation) {
          animation.cancel();
          this.currentAnimation = null;
        }
      });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) this.animate(false);

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
